(() => {
  function init(root = document) {
    const showcases = root.querySelectorAll('craftsmanship-showcase');
    showcases.forEach((showcase) => {
      const autoplayEnabled = String(showcase.dataset.autoplay) === 'true';
      if (!autoplayEnabled) return;

      const videos = showcase.querySelectorAll('video.craftsmanship-showcase__video');
      videos.forEach((video) => {
        // ตั้งค่าให้ครบก่อนพยายาม play
        video.muted = true;
        video.autoplay = true;
        video.playsInline = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('autoplay', '');

        const card = video.closest('.craftsmanship-showcase__video-card');

        const tryPlay = () => {
          // บางเครื่องต้อง load ก่อน
          try { video.load(); } catch (e) {}

          const p = video.play();
          if (p && typeof p.catch === 'function') {
            p.catch(() => {
              // ถ้าโดนบล็อค autoplay ให้รอ gesture ครั้งแรก
              const resume = () => {
                video.play().catch(() => {});
                window.removeEventListener('touchstart', resume, true);
                window.removeEventListener('click', resume, true);
              };
              window.addEventListener('touchstart', resume, true);
              window.addEventListener('click', resume, true);
            });
          }
        };

        // retry หลายจังหวะ กันกรณี DOM ยังไม่พร้อม
        const run = () => {
          tryPlay();
          setTimeout(tryPlay, 150);
          setTimeout(tryPlay, 600);
        };

        if (video.readyState >= 2) run();
        else video.addEventListener('loadeddata', run, { once: true });

        video.addEventListener('playing', () => {
          card?.classList.add('is-playing');
        });
      });
    });
  }

  // โหลดหน้าเว็บปกติ
  document.addEventListener('DOMContentLoaded', () => init(document));

  // Shopify Theme Editor: โหลด/รีโหลด section
  document.addEventListener('shopify:section:load', (e) => {
    init(e.target);
  });
})();